import { v4 as uuidv4 } from 'uuid';

import Constants from '../Constants';
import HandleAsyncError from '../errors/ErrorHandlerDecorator';

import { HttpClient } from './HttpClient';

export default class LoyaltyManagementService extends HttpClient {
  public metricsService: any;

  constructor(metricsService: any) {
    super();
    this.metricsService = metricsService;
  }

  @HandleAsyncError()
  async onGetLoyaltyProgramToggle(token: string, siteId: number): Promise<number> {
    const url = Constants.API.URI.LOYALTY_PROGRAM_TOGGLE.replace('{siteId}', siteId.toString());
    const headers = new Map<string, string>();
    headers.set('X-Trace-Id', uuidv4());

    const response = await super.get(url, token, headers, ['Content-Type']);
    return response.status;
  }
}
